// extracted by mini-css-extract-plugin
module.exports = {"guruScreens":"guru-screens-module--guru-screens--2BoP_","guruScreens__card":"guru-screens-module--guru-screens__card--be-l7"};